import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { TauresMessageModule } from '@taures/taures-components/taures-message';

@Component({
  templateUrl: './bewerbung-eingereicht.component.html',
  styleUrls: ['./bewerbung-eingereicht.component.scss'],
  imports: [RouterLink, Button, TauresMessageModule],
  standalone: true
})
export class BewerbungEingereichtComponent {
  public constructor() {}
}
